import { EuiAccordion, EuiFlexGroup, EuiFlexItem, EuiPanel } from '@elastic/eui';
import React, { useMemo } from 'react';
import { TableDetalle } from '../TablaDetalleVisualizar';
import { toDecimalString } from '../../../../../../../shared/utils/numbers';


export const DespegableDetalle = (props:any) =>{
    const {data,initialIsOpen} = props;
    
    const GetViewDetalleTable = (detalle:any, tipoEmpresa:any, subTipoEmpresa:any) => {
        const _tiposEmpresa = {tipoEmpresa:tipoEmpresa, subTipoEmpresa:subTipoEmpresa} ;

		return (<EuiFlexItem><TableDetalle tiposEmpresa={_tiposEmpresa} data={detalle}/></EuiFlexItem>)
	}

    const Total = useMemo(()=> toDecimalString(data.total.totalFacturaPagar,2),[data])

    return (
        <EuiAccordion id={`detalle-factura-expatriado-${data.total.idEmpresa}`} initialIsOpen={initialIsOpen} paddingSize='xs'
        buttonContent={data.total.empresa} 
        className='acordion-detalle-historico-factura'
        extraAction={<span className='total-detalle-factura-expatriado'>{`Total: ${Total}€`}</span>}
        >
            <EuiPanel paddingSize='l' style={{border:'none',borderRadius:0}}>
                <EuiFlexGroup direction='column'>
                    <EuiFlexItem className='detalle-factura-container'><EuiFlexGroup direction='column'>{GetViewDetalleTable(data.detalle, data.total.tipoEmpresa, data.total.subTipoEmpresa)}</EuiFlexGroup></EuiFlexItem>
                </EuiFlexGroup>
            </EuiPanel>
        </EuiAccordion>
    );
}